import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo, useState } from 'react'
import Select from 'react-select'
import swal from 'sweetalert'
import { FormikProvider, useFormik } from 'formik'
import * as Yup from 'yup'
import Paginate from '../pagination/paginate'
import { uploadSponsorImage } from '../../store/sponsor'
import { EditorState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import { ContentState } from 'draft-js'
import htmlToDraft from 'html-to-draftjs'
import draftToHtml from 'draftjs-to-html'
import { useParams } from 'react-router-dom'
import {
	appCreateEvent,
	appDeleteEvent,
	appGetAllEvent,
	appGetEventDetails,
	appGetUserParticipantsEventDetails,
	appMarkAsPaidEvent,
	appUpdateEvent,
	setEmptyEvent,
} from '../../store/event'
import axios from 'axios'
import { appGetAllUser } from '../../store/user'
import MultipleMediaUpload from '../MultipleMediaUpload'
import ImageUpload from '../ImageUpload'
import PostPreview from '../PostPreview/PostPreview'
// import { appGetAllUser } from "../../store/user";
import Datetime from 'react-datetime'
import moment from 'moment'
import { toast } from 'react-toastify'

import ExportButton from '../../common/ExportButton'
import { eventExportColumns } from '../../config/exportColumns/eventExportColumns'
import { fetchPincodeDetails, toCamelCase } from '../../utils/Function'

const formatUtcDateForIndiaInput = date => {
	if (!date) return ''
	return moment
		.utc(date)
		.utcOffset(330)
		.format('YYYY-MM-DD')
}

function Event({ event, eventpage, setEventPage, sansthaDetails }) {
	//console.log(sansthaDetails)
	const dispatch = useDispatch()
	const { id } = useParams()
	const [showModal, setShowModal] = useState(false)
	const [editEventMode, setEditEventMode] = useState(false)
	const [editId, setEditId] = useState(null)
	const [editorValues, setValues] = useState(EditorState.createEmpty())
	const users = useSelector(state => state?.usersReducer.users)
	const eventpaginate = useSelector(state => state.eventReducer.paginate)
	const [selectedArea, setSelectedArea] = useState(null)
	const [areaList, setAreaList] = useState([])
	const eventDetails = useSelector(state => state.eventReducer.eventDetails)
	const [showEventDetailsModal, setShowEventDetailsModal] = useState(false)
	const [showPaymentPopup, setShowPaymentPopup] = useState(false)
	const [createdEventId, setCreatedEventId] = useState(null)
	const [filterCategory, setFilterCategory] = useState(null)
	const [appliedCategory, setAppliedCategory] = useState(null)
	const eventParticipantUserDetails = useSelector(
		state => state.eventReducer.eventParticipantUserDetails,
	)
	const participants = Array.isArray(eventParticipantUserDetails) ? eventParticipantUserDetails : []
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	const userData = JSON.parse(localStorage.getItem('user') || '{}')
	const hubId = userData.hub

	const getUserOptionLabel = user => {
		if (!user) return 'Unknown User'

		const name = [user.firstName, user.lastName]
			.filter(Boolean)
			.join(' ')
			.trim()
		const mobile = user.mobile ? ` (${user.mobile})` : ''

		return `${name || 'Unknown User'}${mobile}`
	}

	useEffect(() => {
		dispatch(appGetAllUser({ page: 1, limit: 1000, sansthaId: sansthaDetails._id }))
		if (editId) {
			dispatch(appGetEventDetails(editId))
		}
		return () => {
			dispatch(setEmptyEvent())
		}
	}, [dispatch, sansthaDetails, editId])

	useEffect(() => {
		const params = {
			page: eventpage,
			limit: 10,
		}

		if (sansthaDetails?._id) {
			params.sanstha = sansthaDetails._id
		}

		if (appliedCategory) {
			params.categoryOptions = appliedCategory
		}

		dispatch(appGetAllEvent(params))
	}, [eventpage, appliedCategory, sansthaDetails?._id])

	const categoryOptions = [
		{ value: 'Cultural', label: 'Cultural' },
		{ value: 'Religious', label: 'Religious' },
		{ value: 'Wedding', label: 'Wedding' },
		{ value: 'General Meeting', label: 'General Meeting' },
		{ value: 'Medical Camp', label: 'Medical Camp' },
		{ value: 'Workshop', label: 'Workshop' },
		{ value: 'Sports', label: 'Sports' },
		{ value: 'Talent Show', label: 'Talent Show' },
		{ value: 'Donation Drive', label: 'Donation Drive' },
		{ value: 'Matrimonial Meet', label: 'Matrimonial Meet' },
		{ value: 'Family Gathering', label: 'Family Gathering' },
		{ value: 'Felicitation', label: 'Felicitation' },
		{ value: 'Blood Donation Camp', label: 'Blood Donation Camp' },
		{ value: 'Free Eye Checkup', label: 'Free Eye Checkup' },
		{ value: 'Housewarming', label: 'Housewarming' },
		{ value: 'Anniversary', label: 'Anniversary' },
		{ value: 'Personal Puja', label: 'Personal Puja' },
	]

	const onEditorStateChange = editorState => {
		formik.setFieldValue('description', draftToHtml(convertToRaw(editorState.getCurrentContent())))
		setValues(editorState)
	}

	const validationSchema = Yup.object({
		eventpaid: Yup.boolean().required('Event type is required'),
		amount: Yup.string().when('eventpaid', {
			is: true,
			then: schema =>
				schema
					.required('Amount is required for paid events')
					.matches(/^[0-9]+(\.[0-9]{1,2})?$/, 'Enter a valid number')
					.test('positive', 'Amount must be greater than zero', val => parseFloat(val) > 0),
			otherwise: schema =>
				schema.test('empty', 'Amount must be empty for free events', val => !val),
		}),
		title: Yup.string().required('Event title is required'),
		description: Yup.string()
			.transform(value => {
				if (!value) return ''
				return value
					.replace(/<[^>]+>/g, '')
					.replace(/&nbsp;/gi, '')
					.replace(/\s+/g, '')
					.trim()
			})
			.test('is-not-empty', 'Description is Required', value => value && value.length > 0)
			.required('Description is Required'),
		category: Yup.string().required('Category is required'),
		file: Yup.string()
			.nullable()
			.required('Please upload a file')
			.test('is-valid-url', 'Invalid image', value => {
				return value && value !== '/img/default-placeholder.jpg'
			}),
		startDate: Yup.date()
			// .nullable()
			.required('Start date is required'),
		endDate: Yup.date()
			// .nullable()
			.required('End date is required'),
		locationType: Yup.string().required('Location type is required'),
		virtualLink: Yup.string().when('locationType', {
			is: 'Virtual',
			then: schema => schema.required('Virtual link is required'),
			otherwise: schema => schema.notRequired(),
		}),
		nativePlacePincode: Yup.string().when('locationType', {
			is: 'Physical',
			then: schema => schema.required('Pincode is required'),
			otherwise: schema => schema.notRequired(),
		}),
		nativeArea: Yup.string().when('locationType', {
			is: 'Physical',
			then: schema => schema.required('Area is required'),
			otherwise: schema => schema.notRequired(),
		}),
		nativeState: Yup.string().when('locationType', {
			is: 'Physical',
			then: schema => schema.required('State is required'),
			otherwise: schema => schema.notRequired(),
		}),
		nativeDistrict: Yup.string().when('locationType', {
			is: 'Physical',
			then: schema => schema.required('District is required'),
			otherwise: schema => schema.notRequired(),
		}),
		nativeBlock: Yup.string().when('locationType', {
			is: 'Physical',
			then: schema => schema.required('Taluka is required'),
			otherwise: schema => schema.notRequired(),
		}),
		nativePlaceAddress: Yup.string().when('locationType', {
			is: 'Physical',
			then: schema => schema.required('Address is required'),
			otherwise: schema => schema.notRequired(),
		}),
		boli_items: Yup.array().notRequired(),
	})

	const formik = useFormik({
		initialValues: {
			eventpaid: false,
			amount: '',
			sanstha: sansthaDetails?._id || sansthaId || permissionOfSanstha,
			hub: sansthaDetails?.hub || hubId,
			title: '',
			description: '',
			file: '',
			// fileType: null,
			category: '',
			startDate: '',
			endDate: '',
			startTime: moment().format('hh:mm a'),
			endTime: moment().format('hh:mm a'),
			volunteers: [],
			locationType: '',
			virtualLink: '',
			nativePlacePincode: '',
			nativeArea: '',
			nativeState: '',
			nativeDistrict: '',
			nativeBlock: '',
			nativePlaceAddress: '',
			RSVP_Enabled: false,
			Waitlist_Enabled: false,
			RSVP_deadline: '',
			RSVP_limit: '',
			upi_id: '',
			Allow_Vlonteers: false,
			allow_photo_upload: false,
			payment_mode_enabled: false,
			boli_items: [],
			event_photo_upload: [],
		},
		context: { createdEventId },
		// enableReinitialize: true,
		validationSchema,
		onSubmit: values => {
			//	console.log(values)
			const payload = {
				eventpaid: values.eventpaid,
				amount: values.amount,
				title: values.title,
				description: values.description,
				sanstha: values.sanstha,
				hub: values.hub,
				file: values.file,
				// fileType: values.fileType,
				category: values.category,
				startDate: values.startDate,
				endDate: values.endDate,
				startTime: values.startTime,
				endTime: values.endTime,
				volunteers: values.volunteers,
				locationType: values.locationType,
				virtualLink: values.virtualLink,
				nativePlacePincode: values.nativePlacePincode,
				nativeArea: values.nativeArea,
				nativeState: values.nativeState,
				nativeDistrict: values.nativeDistrict,
				nativeBlock: values.nativeBlock,
				nativePlaceAddress: values.nativePlaceAddress,
				RSVP_Enabled: values.RSVP_Enabled,
				Waitlist_Enabled: values.Waitlist_Enabled,
				RSVP_deadline: values.RSVP_Enabled ? values.RSVP_deadline : null,
				RSVP_limit: values.RSVP_Enabled ? values.RSVP_limit : '',
				upi_id: values.payment_mode_enabled ? values.upi_id : '',
				Allow_Vlonteers: values.Allow_Vlonteers,
				allow_photo_upload: values.allow_photo_upload,
				payment_mode_enabled: values.payment_mode_enabled,
				boli_items: values.payment_mode_enabled ? values.boli_items : [],
				event_photo_upload: values.allow_photo_upload ? values.event_photo_upload : '',
				// navigate: navigate,
			}
			//console.log(payload)

			const filtered_obj = Object.fromEntries(
				Object.entries(payload).filter(
					([key, value]) =>
						value !== '' && value !== null && value !== undefined && key !== 'navigate',
				),
			)

			if (editEventMode && editId) {
				dispatch(appUpdateEvent({ ...filtered_obj, id: editId })).then(() => {
					dispatch(
						appGetAllEvent({
							page: 1,
							limit: 10,
							sanstha: sansthaDetails?._id,
						}),
					)
				})
			} else {
				dispatch(appCreateEvent(filtered_obj)).then(action => {
					if (action?.payload?.data?._id) {
						//console.log(action.payload)
						setCreatedEventId(action.payload?.data?._id)
						setShowPaymentPopup(true)
					}
					dispatch(
						appGetAllEvent({
							page: 1,
							limit: 10,
							sanstha: sansthaDetails?._id,
						}),
					)
				})
			}

			// formik.resetForm();
			setShowModal(false)
			setEditEventMode(false)
			setEditId(null)
		},
	})

	const getFirstError = errors => {
		for (const value of Object.values(errors)) {
			if (typeof value === 'string') return value
			if (Array.isArray(value)) {
				const nestedError = value.find(Boolean)
				if (nestedError && typeof nestedError === 'object') {
					const message = getFirstError(nestedError)
					if (message) return message
				}
				if (typeof nestedError === 'string') return nestedError
			}
			if (value && typeof value === 'object') {
				const message = getFirstError(value)
				if (message) return message
			}
		}

		return ''
	}

	const handleEventFormSubmit = async e => {
		e.preventDefault()

		const errors = await formik.validateForm()

		if (Object.keys(errors).length) {
			formik.setTouched(
				Object.keys(errors).reduce((acc, key) => {
					acc[key] = true
					return acc
				}, {}),
			)
			toast.error(getFirstError(errors) || 'Please fix validation errors before saving')
			return
		}

		await formik.submitForm()
	}

	// const fetchPincodeDetails = async pincode => {
	// 	try {
	// 		const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`)
	// 		const data = response.data[0]

	// 		if (data.Status === 'Success') {
	// 			return data.PostOffice
	// 		}
	// 		return []
	// 	} catch (error) {
	// 		console.error('Error fetching pincode details:', error)
	// 		return []
	// 	}
	// }
	const handlePincodeBlur = async e => {
		formik.handleBlur(e)

		const pincode = e.target.value
		//console.log(pincode)
		if (pincode && pincode.length === 6) {
			const postOffices = await fetchPincodeDetails(pincode)
			setAreaList(postOffices)
		}
	}
	useEffect(() => {
		const fetchAreaOnEdit = async () => {
			if (event?.data && id) {
				const selectedevent = Array.isArray(event?.data)
					? event?.data.find(c => c._id === id)
					: event?.data

				if (selectedevent?.pincode) {
					const postOffices = await fetchPincodeDetails(selectedevent?.pincode)
					setAreaList(postOffices)
				}
			}
		}

		fetchAreaOnEdit()
	}, [event?.data, id])

	const handleAddNewEvent = () => {
		setEditId(null)
		setEditEventMode(false)
		formik.resetForm()
		formik.setValues({
			eventpaid: false,
			amount: '',
			hub: sansthaDetails?.hub || '',
			sanstha: sansthaDetails?._id || '',
			title: '',
			description: '',
			file: '',
			// fileType: null,
			category: '',
			startDate: '',
			endDate: '',
			startTime: moment().format('hh:mm a'),
			endTime: moment().format('hh:mm a'),
			volunteers: [],
			locationType: '',
			virtualLink: '',
			nativePlacePincode: '',
			nativeArea: '',
			nativeState: '',
			nativeDistrict: '',
			nativeBlock: '',
			nativePlaceAddress: '',
			RSVP_Enabled: false,
			Waitlist_Enabled: false,
			RSVP_deadline: '',
			RSVP_limit: '',
			upi_id: '',
			Allow_Vlonteers: false,
			allow_photo_upload: false,
			payment_mode_enabled: false,
			boli_items: [],
			event_photo_upload: [],
		})
		setValues(EditorState.createEmpty())
		setShowModal(true)
	}

	useEffect(() => {
		if (editEventMode && eventDetails && eventDetails._id === editId) {
			populateFormData()
		}
	}, [eventDetails, editEventMode, editId])

	const populateFormData = () => {
		if (!eventDetails) {
			formik.resetForm()
			setValues(EditorState.createEmpty())
			return
		}

		if (eventDetails.description) {
			const blocksFromHtml = htmlToDraft(eventDetails.description)
			const { contentBlocks, entityMap } = blocksFromHtml
			const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
			setValues(EditorState.createWithContent(contentState))
		} else {
			setValues(EditorState.createEmpty())
		}

		formik.setValues({
			eventpaid: eventDetails.eventpaid ?? false,
			amount: eventDetails.amount || '',
			hub: eventDetails.hub?._id || sansthaDetails?.hub || '',
			sanstha: eventDetails.sanstha?._id || sansthaDetails?._id || '',
			title: eventDetails.title || '',
			description: eventDetails.description || '',
			file: eventDetails.file || '',
			fileType: null,
			category: eventDetails.category || '',
			startDate: formatUtcDateForIndiaInput(eventDetails.startDate),
			endDate: formatUtcDateForIndiaInput(eventDetails.endDate),
			startTime: eventDetails.startTime
				? moment(eventDetails.startTime, 'HH:mm a').format('hh:mm a')
				: moment().format('hh:mm a'),
			endTime: eventDetails.endTime
				? moment(eventDetails.endTime, 'HH:mm a').format('hh:mm a')
				: moment().format('hh:mm a'),
			volunteers: eventDetails.volunteers || [],
			locationType: eventDetails.locationType || '',
			virtualLink: eventDetails.virtualLink || '',
			nativePlacePincode: eventDetails.nativePlacePincode || '',
			nativeArea: eventDetails.nativeArea || '',
			nativeState: eventDetails.nativeState || '',
			nativeDistrict: eventDetails.nativeDistrict || '',
			nativeBlock: eventDetails.nativeBlock || '',
			nativePlaceAddress: eventDetails.nativePlaceAddress || '',
			RSVP_Enabled: eventDetails.RSVP_Enabled || false,
			Waitlist_Enabled: eventDetails.Waitlist_Enabled || false,
			RSVP_deadline: eventDetails.RSVP_deadline
				? new Date(eventDetails.RSVP_deadline).toISOString().slice(0, 10)
				: '',
			RSVP_limit: eventDetails.RSVP_limit || '',
			upi_id: eventDetails.upi_id || '',
			Allow_Vlonteers: eventDetails.Allow_Vlonteers || false,
			allow_photo_upload: eventDetails.allow_photo_upload || false,
			payment_mode_enabled: eventDetails.payment_mode_enabled || false,
			boli_items: eventDetails.boli_items || [],
			event_photo_upload: eventDetails.event_photo_upload || [],
		})
	}

	const handleEditEvent = async eventId => {
		setEditId(eventId)
		setEditEventMode(true)
		setShowModal(true)

		try {
			await dispatch(appGetEventDetails(eventId))
		} catch (error) {
			console.error('Error fetching event details:', error)
		}
	}
	const handleDeleteEvent = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this Event?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(appDeleteEvent(id)).then(() => {
					dispatch(
						appGetAllEvent({
							page: 1,
							limit: 10,
							sanstha: sansthaDetails?._id,
						}),
					)
				})
			}
		})
	}

	const handleShowEventDetails = eventId => {
		// console.log(eventId);
		dispatch(appGetEventDetails(eventId))
		dispatch(
			appGetUserParticipantsEventDetails({
				event: eventId,
				// status: "Accepted",
			}),
		)
		// setSelectedEventDetails(eventDetails);
		setShowEventDetailsModal(true)
	}

	const handleCloseEventDetails = () => {
		setShowEventDetailsModal(false)
		dispatch(setEmptyEvent())
	}

	const handleCloseEventEdit = () => {
		setShowModal(false)
		setEditEventMode(false)
		setEditId(null)

		formik.resetForm()
		setValues(EditorState.createEmpty())

		dispatch(setEmptyEvent())
	}

	const handleCloseModal = () => {
		setShowPaymentPopup(false)
		// navigate("/event")
	}

	const eventId = createdEventId || editId || id || eventDetails?._id

	const refreshEventData = eventToRefresh => {
		if (eventToRefresh) {
			dispatch(appGetEventDetails(eventToRefresh)).then(action => {
				if (Array.isArray(action?.payload?.boli_items)) {
					formik.setFieldValue('boli_items', action.payload.boli_items)
				}
			})
		}
	}

	const handleMarkAsPaid = (index, sponsorIndex, sponsor) => {
		const boliItem = formik.values.boli_items[index]
		const boliItemName = boliItem?.item_name

		const userId = typeof sponsor.userId === 'object' ? sponsor.userId._id : sponsor.userId

		swal({
			title: 'Are you sure?',
			text: `Do you want to mark "${boliItemName}" as Paid?`,
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willConfirm => {
			if (willConfirm) {
				dispatch(
					appMarkAsPaidEvent({
						event: eventId,
						userId: userId,
						item_name: boliItemName,
						amount: sponsor.amount,
						boliPaymentId: sponsor?._id,
					}),
				).then(action => {
					if (action?.error) {
						return
					}

					const updated = formik.values.boli_items.map((item, itemIndex) =>
						itemIndex === index
							? {
									...item,
									sponsored_by: item.sponsored_by.map((itemSponsor, itemSponsorIndex) =>
										itemSponsorIndex === sponsorIndex
											? {
													...itemSponsor,
													status: 'Paid',
											  }
											: itemSponsor,
									),
							  }
							: item,
					)

					formik.setFieldValue('boli_items', updated)
					refreshEventData(eventId)
				})
			}
		})
	}

	const handleSave = async () => {
		const errors = await formik.validateForm()
		//console.log(errors)

		formik.setTouched(
			Object.keys(errors).reduce((acc, key) => {
				acc[key] = true
				return acc
			}, {}),
		)

		if (Object.keys(errors).length) {
			toast.error('Please fix validation errors before saving')
			return
		}
		const normalizedBoliItems = formik.values.boli_items.map(item => ({
			...item,
			sponsored_by: item.sponsored_by.map(sponsor => ({
				...sponsor,
				status: sponsor.status || 'Pending',
			})),
		}))

		const updatePayload = {
			id: createdEventId,
			payment_mode_enabled: formik.values.payment_mode_enabled,
			upi_id: formik.values.upi_id,
			boli_items: normalizedBoliItems,
		}

		dispatch(appUpdateEvent(updatePayload)).then(() => {
			setShowPaymentPopup(false)
			// navigate("/event");
		})
	}

	const getCreatorName = value => {
		if (value?.userId) {
			return (
				<div className="d-flex flex-column align-items-center">
					<PostPreview value={value?.userId?.profilePic || '/img/user.jpg'} />

					<span className="fw-semibold mt-1">
						{value?.userId?.firstName} {value?.userId?.lastName}
					</span>

					<small className="text-muted">{value?.userId?.mobile}</small>
				</div>
			)
		}

		if (value?.superAdmin) {
			return (
				<div className="d-flex flex-column align-items-center">
					<span className="badge badge-success mt-1">Super Admin</span>
				</div>
			)
		}

		if (value?.hubAdmin) {
			return (
				<div className="d-flex flex-column align-items-center">
					<PostPreview value={value?.hub?.admin?.profilePic || '/img/user.jpg'} />

					<small className="fw-semibold mt-1 mb-0 d-block lh-sm">
						{value?.hub?.admin?.firstName} {value?.hub?.admin?.lastName}
					</small>

					<small className="text-muted d-block lh-sm">{value?.hub?.admin?.mobile}</small>

					<span className="badge badge-primary mt-1">Community Admin</span>
				</div>
			)
		}

		if (value?.sansthAdmin) {
			return (
				<div className="d-flex flex-column align-items-center">
					<PostPreview value={value?.sanstha?.admin?.profilePic || '/img/user.jpg'} />

					<small className="fw-semibold mt-1 mb-0 d-block lh-sm">
						{value?.sanstha?.admin?.firstName} {value?.sanstha?.admin?.lastName}
					</small>

					<small className="text-muted d-block lh-sm">{value?.sanstha?.admin?.mobile}</small>

					<span className="badge badge-primary">Sanstha Admin</span>
				</div>
			)
		}

		return (
			<div className="d-flex flex-column align-items-center">
				<span className="badge badge-success mt-1">Super Admin</span>
			</div>
		)
	}

	return (
		<>
			<div className="d-flex gap-2 mb-3 ml-5">
				<Select
					options={categoryOptions}
					value={categoryOptions.find(opt => opt.value === filterCategory) || null}
					onChange={opt => setFilterCategory(opt?.value || null)}
					placeholder="Select Category..."
					isClearable
					style={{ minWidth: '220px' }}
				/>

				<button
					className="btn btn-primary mx-2"
					onClick={() => {
						setAppliedCategory(filterCategory || null)
						setEventPage(1)
					}}
				>
					Search
				</button>

				<button
					className="btn btn-secondary"
					onClick={() => {
						setFilterCategory(null)
						setAppliedCategory(null)
						setEventPage(1)
					}}
				>
					Reset
				</button>
			</div>
			<div className="mb-3 d-flex justify-content-end align-items-center">
				<ExportButton
					fetchAction={params =>
						dispatch(
							appGetAllEvent({
								...params,
								page: 1,
								limit: 100000,
								sanstha: sansthaId || permissionOfSanstha,
								loading: false,
							}),
						)
					}
					columns={eventExportColumns}
					fileName="Events"
					sheetName="Events"
					buttonText="Export Events"
					className="btn btn-info mr-2"
				/>

				<button
					className="btn btn-primary"
					style={{ marginLeft: '10px' }}
					onClick={handleAddNewEvent}
				>
					Add Event
				</button>
			</div>

			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead>
						<tr>
							<th>Image</th>
							<th>Event</th>
							<th>Category</th>
							<th>Community</th>
							<th>Sanstha</th>
							<th>Recived Amount (Rs) </th>
							<th>Start Date</th>
							<th>End Date</th>
							<th>Status</th>
							<th>Posted by</th>
						</tr>
					</thead>
					<tbody>
						{(event.data || []).map(value => (
							<tr key={value._id}>
								<PostPreview value={value} />
								<td
									className="text-capitalize"
									style={{
										maxWidth: '150px',
										wordWrap: 'break-word',
										whiteSpace: 'normal',
									}}
								>
									{value.title}
								</td>
								<td>{value.category}</td>
								<td
									style={{
										maxWidth: '150px',
										wordWrap: 'break-word',
										whiteSpace: 'normal',
										textTransform: 'capitalize',
									}}
								>
									{value?.hub ? (
										<>
											{value.hub.image && <PostPreview value={value.hub.image} />}
											{toCamelCase(value?.hub?.name) || '—'}
										</>
									) : (
										''
									)}
								</td>
								<td
									style={{
										maxWidth: '150px',
										wordWrap: 'break-word',
										whiteSpace: 'normal',
										textTransform: 'capitalize',
									}}
								>
									{value?.sanstha ? (
										<>
											{value.sanstha.image && <PostPreview value={value.sanstha.image} />}
											{toCamelCase(value?.sanstha?.name) || '—'}
										</>
									) : (
										''
									)}
								</td>
								<td style={{ textAlign: 'center' }}>{value?.receivedAmount || 0}</td>
								<td>
									{new Date(value.startDate).toLocaleDateString('en-US', {
										year: 'numeric',
										month: 'short',
										day: 'numeric',
									})}
								</td>
								<td>
									{new Date(value.endDate).toLocaleDateString('en-US', {
										year: 'numeric',
										month: 'short',
										day: 'numeric',
									})}
								</td>
								<td>
									<span
										className={`badge ${
											value?.status === 'Upcoming'
												? 'badge-warning'
												: value?.status === 'Active'
												? 'badge-success'
												: value?.status === 'Completed'
												? 'badge-danger'
												: 'badge-light'
										}`}
									>
										{value?.status || 'N/A'}
									</span>
								</td>

								<td
									style={{
										maxWidth: '150px',
										wordWrap: 'break-word',
										whiteSpace: 'normal',
									}}
								>
									{getCreatorName(value)}
								</td>

								<td>
									<button
										className="btn btn-sm btn-info mr-2"
										onClick={() => handleEditEvent(value?._id)}
									>
										<em className="fa fa-edit fa-fw"></em>
									</button>
									<button
										onClick={e => {
											e.preventDefault()
											e.stopPropagation()
											handleShowEventDetails(value?._id)
										}}
										className="btn btn-sm btn-primary mr-2"
										title="Details"
									>
										<em className="fa fa-eye fa-fw"></em>
									</button>
									<button
										className="btn btn-sm btn-danger"
										onClick={() => handleDeleteEvent(value._id)}
									>
										<em className="fa fa-trash fa-fw"></em>
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<Paginate paginate={eventpaginate} page={eventpage} setPage={setEventPage} />

			{showModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">{editEventMode ? 'Edit Event' : 'Create New Event'}</h5>
								<button type="button" className="close" onClick={handleCloseEventEdit}>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
								<FormikProvider value={formik}>
								<form onSubmit={handleEventFormSubmit}>
									<div className="row mb-3">
										<div className="col-md-6">
											<label>
												Event<span className="text-danger">*</span>
											</label>
											<select
												className="form-control"
												name="eventpaid"
												value={formik.values.eventpaid ? 'Paid' : 'Free'}
												onChange={e => {
													const isPaid = e.target.value === 'Paid'
													formik.setFieldValue('eventpaid', isPaid)
													if (!isPaid) {
														formik.setFieldValue('amount', '')
													}
												}}
												onBlur={formik.handleBlur}
											>
												<option value="Free">Free</option>
												<option value="Paid">Paid</option>
											</select>
											{formik.touched.eventpaid && formik.errors.eventpaid && (
												<div className="text-danger">{formik.errors.eventpaid}</div>
											)}
										</div>

										{formik.values.eventpaid && (
											<div className="col-md-6">
												<label>
													Amount<span className="text-danger">*</span>
												</label>
												<input
													type="text"
													name="amount"
													className="form-control"
													value={formik.values.amount}
													onChange={formik.handleChange}
													placeholder="Enter amount"
												/>
												{formik.touched.amount && formik.errors.amount && (
													<div className="text-danger">{formik.errors.amount}</div>
												)}
											</div>
										)}
									</div>
									<div className="row">
										<div className="col-md-6">
											<label>
												Event Title <span className="text-danger">*</span>
											</label>
											<input
												type="text"
												name="title"
												className="form-control"
												value={formik.values.title}
												onChange={formik.handleChange}
												placeholder="Enter event title"
											/>
											{formik.touched.title && formik.errors.title && (
												<div className="text-danger">{formik.errors.title}</div>
											)}
										</div>

										<div className="col-md-6">
											<label>
												Event Description <span className="text-danger">*</span>
											</label>
											<Editor
												editorClassName="form-control"
												editorState={editorValues}
												onEditorStateChange={onEditorStateChange}
												onBlur={() => formik.setFieldTouched('description', true)}
												editorStyle={{ height: 300 }}
											/>
											{formik.touched.description && formik.errors.description && (
												<div className="text-danger">{formik.errors.description}</div>
											)}
										</div>
										<div className="mb-3 col-md-6">
											<ImageUpload
												fieldName="media"
												value={formik.values.file || ''}
												label="Event Banner *"
												uploadFunction={uploadSponsorImage}
												onChange={value => formik.setFieldValue('file', value.url)}
												error={
													formik.touched.file && formik.errors.file ? formik.errors.file : null
												}
											/>
										</div>
									</div>

									<div className="row mb-3">
										<div className="col-md-6">
											<label>
												Category <span className="text-danger">*</span>
											</label>
											<Select
												name="category"
												options={categoryOptions}
												onChange={opt => formik.setFieldValue('category', opt?.value)}
												value={
													categoryOptions.find(o => o.value === formik.values.category) || null
												}
												placeholder="Select category..."
											/>
											{formik.touched.category && formik.errors.category && (
												<div className="text-danger">{formik.errors.category}</div>
											)}
										</div>
									</div>

									<div className="row mb-3">
										<div className="col-md-6">
											<label>
												Start Date <span className="text-danger">*</span>
											</label>
											<input
												type="date"
												name="startDate"
												className="form-control"
												value={formik.values.startDate}
												onChange={e => {
													const value = e.target.value
													formik.setFieldValue('startDate', value)
													if (formik.values.endDate && formik.values.endDate < value) {
														formik.setFieldValue('endDate', '')
													}
												}}
											/>
											{formik.touched.startDate && formik.errors.startDate && (
												<div className="text-danger">{formik.errors.startDate}</div>
											)}
										</div>
										<div className="col-md-6">
											<label>
												End Date <span className="text-danger">*</span>
											</label>
											<input
												type="date"
												name="endDate"
												className="form-control"
												value={formik.values.endDate}
												onChange={e => {
													const value = e.target.value
													formik.setFieldValue('endDate', value)
												}}
											/>
											{formik.touched.endDate && formik.errors.endDate && (
												<div className="text-danger">{formik.errors.endDate}</div>
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-md-6">
											<label>Start Time</label>
											<Datetime
												dateFormat={false}
												timeFormat="hh:mm a"
												value={
													formik.values.startTime
														? moment(formik.values.startTime, 'hh:mm a')
														: null
												}
												onChange={val => {
													const formatted = moment(val).format('hh:mm a')
													formik.setFieldValue('startTime', formatted)
												}}
												inputProps={{
													placeholder: 'Select Start Time',
													style: { cursor: 'pointer' },
												}}
											/>
										</div>

										<div className="col-md-6">
											<label>End Time</label>
											<Datetime
												dateFormat={false}
												timeFormat="hh:mm a"
												value={
													formik.values.endTime ? moment(formik.values.endTime, 'hh:mm a') : null
												}
												onChange={val => {
													const formatted = moment(val).format('hh:mm a')
													formik.setFieldValue('endTime', formatted)
												}}
												inputProps={{
													placeholder: 'Select End Time',
													style: { cursor: 'pointer' },
												}}
											/>
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-md-6">
											<div className="form-group">
												<label>locationType </label>
												<select
													className="form-control"
													name="locationType"
													value={formik.values.locationType}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
												>
													<option value="">Select locationType</option>
													<option value="Physical">Physical </option>
													<option value="Virtual">Virtual </option>
													{/* <option value="Hybrid">Hybrid</option> */}
												</select>
											</div>
										</div>
										{formik.values.locationType === 'Virtual' && (
											<div className="col-md-6">
												<label>Event virtualLink</label>
												<input
													type="text"
													name="virtualLink"
													className="form-control"
													value={formik.values.virtualLink}
													onChange={formik.handleChange}
													placeholder="Enter post virtualLink"
												/>
												{formik.touched.virtualLink && formik.errors.virtualLink && (
													<div className="text-danger">{formik.errors.virtualLink}</div>
												)}
											</div>
										)}
									</div>

									{formik.values.locationType === 'Physical' && (
										<div className="row" style={{ padding: '0 0 15px 0' }}>
											{/* Pincode */}
											<div className="col-md-6 mb-3">
												<label>Pincode</label>
												<input
													className="form-control"
													name="nativePlacePincode"
													type="number"
													onChange={formik.handleChange}
													onBlur={handlePincodeBlur}
													value={formik.values.nativePlacePincode}
												/>
												{formik.touched.nativePlacePincode && formik.errors.nativePlacePincode && (
													<div className="text-danger">{formik.errors.nativePlacePincode}</div>
												)}
											</div>

											{/* Select Area */}
											<div className="col-md-6 mb-3">
												<label>Select Area</label>
												<select
													className="form-control"
													name="nativeArea"
													onChange={e => {
														const selected = areaList.find(a => a.Name === e.target.value)
														setSelectedArea(selected)
														formik.setFieldValue('nativeArea', e.target.value)
														formik.setFieldValue('nativeState', selected?.State || '')
														formik.setFieldValue('nativeDistrict', selected?.District || '')
														formik.setFieldValue('nativeBlock', selected?.Block || '')
													}}
													value={formik.values.nativeArea || ''}
												>
													<option value="">Select Area</option>
													{areaList.map(area => (
														<option key={area.Name} value={area.Name}>
															{area.Name}
														</option>
													))}
												</select>
												{formik.touched.nativeArea && formik.errors.nativeArea && (
													<div className="text-danger">{formik.errors.nativeArea}</div>
												)}
											</div>

											{/* State */}
											<div className="col-md-6 mb-3">
												<label>State</label>
												<input
													className="form-control"
													name="nativeState"
													type="text"
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													value={formik.values.nativeState}
												/>
												{formik.touched.nativeState && formik.errors.nativeState && (
													<div className="text-danger">{formik.errors.nativeState}</div>
												)}
											</div>

											{/* District */}
											<div className="col-md-6 mb-3">
												<label>District</label>
												<input
													className="form-control"
													name="nativeDistrict"
													type="text"
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													value={formik.values.nativeDistrict}
												/>
												{formik.touched.nativeDistrict && formik.errors.nativeDistrict && (
													<div className="text-danger">{formik.errors.nativeDistrict}</div>
												)}
											</div>

											{/* Taluka */}
											<div className="col-md-6 mb-3">
												<label>Taluka</label>
												<input
													className="form-control"
													name="nativeBlock"
													type="text"
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													value={formik.values.nativeBlock}
												/>
												{formik.touched.nativeBlock && formik.errors.nativeBlock && (
													<div className="text-danger">{formik.errors.nativeBlock}</div>
												)}
											</div>

											{/*  Address */}
											<div className="col-md-12 mb-3">
												<label>Address</label>
												<input
													className="form-control"
													name="nativePlaceAddress"
													type="text"
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													value={formik.values.nativePlaceAddress}
												/>
												{formik.touched.nativePlaceAddress && formik.errors.nativePlaceAddress && (
													<div className="text-danger">{formik.errors.nativePlaceAddress}</div>
												)}
											</div>
										</div>
									)}

									<div className="row mb-3">
										<div className="col-md-6">
											<label className="form-label">RSVP enabled</label>
											<div>
												<label className="me-3">
													<input
														type="radio"
														name="RSVP_Enabled"
														checked={formik.values.RSVP_Enabled === true}
														onChange={() => formik.setFieldValue('RSVP_Enabled', true)}
													/>{' '}
													Yes
												</label>
												<label className="ml-3">
													<input
														type="radio"
														name="RSVP_Enabled"
														checked={formik.values.RSVP_Enabled === false}
														onChange={() => formik.setFieldValue('RSVP_Enabled', false)}
													/>{' '}
													No
												</label>
											</div>
										</div>
										{formik.values.RSVP_Enabled && (
											<div className="col-md-6">
												<label>RSVP Date</label>
												<input
													type="date"
													name="RSVP_deadline"
													className="form-control"
													value={formik.values.RSVP_deadline}
													onChange={e => {
														const value = e.target.value
														formik.setFieldValue('RSVP_deadline', value)
													}}
												/>
												{formik.touched.RSVP_deadline && formik.errors.RSVP_deadline && (
													<div className="text-danger">{formik.errors.RSVP_deadline}</div>
												)}
											</div>
										)}
									</div>

									<div className="row">
										<div className="col-md-6">
											<label className="form-label">Waitlist enabled</label>
											<div>
												<label className="me-3">
													<input
														type="radio"
														name="Waitlist_Enabled"
														checked={formik.values.Waitlist_Enabled === true}
														onChange={() => formik.setFieldValue('Waitlist_Enabled', true)}
													/>{' '}
													Yes
												</label>
												<label className="ml-3">
													<input
														type="radio"
														name="Waitlist_Enabled"
														checked={formik.values.Waitlist_Enabled === false}
														onChange={() => formik.setFieldValue('Waitlist_Enabled', false)}
													/>{' '}
													No
												</label>
											</div>
										</div>
										{formik.values.RSVP_Enabled && (
											<div className="col-md-6">
												<label>RSVP Limit</label>
												<input
													type="number"
													name="RSVP_limit"
													className="form-control"
													value={formik.values.RSVP_limit}
													onChange={formik.handleChange}
													placeholder="Enter event RSVP Limit"
												/>
												{formik.touched.RSVP_limit && formik.errors.RSVP_limit && (
													<div className="text-danger">{formik.errors.RSVP_limit}</div>
												)}
											</div>
										)}
									</div>
									<div className="mb-3">
										<div className="col-md-6 form-check">
											<div className="form-group">
												<input
													type="checkbox"
													name="Allow_Vlonteers"
													checked={formik.values.Allow_Vlonteers}
													onChange={formik.handleChange}
													className="form-check-input"
													id="Allow_Vlonteers"
												/>
											</div>
											<label className="form-check-label" htmlFor="Allow_Vlonteers">
												Allow volunteers
											</label>
										</div>
									</div>
									{formik.values.Allow_Vlonteers && (
										<div className="row">
											<div className="col-md-12 mb-3">
												<button
													type="button"
													className="btn btn-primary"
													onClick={() => {
														const updated = [
															...formik.values.volunteers,
															{
																userId: [],
																role: '',
																remaining_count: '',
																// , status: "Pending"
															},
														]
														formik.setFieldValue('volunteers', updated)
													}}
												>
													Add Volunteer
												</button>
											</div>
											{formik.values.volunteers?.map((volunteer, index) => (
												<div className="col-md-12 mb-3 d-flex align-items-center gap-2" key={index}>
													<div className="flex-grow-1">
														<Select
															options={
																Array.isArray(users)
																	? users.map(user => ({
																			value: user._id,
																			label: user.firstName,
																	  }))
																	: []
															}
															value={
																Array.isArray(volunteer.userId)
																	? volunteer.userId.map(u => ({
																			value: u._id,
																			label: u.firstName,
																	  }))
																	: []
															}
															onChange={selectedOptions => {
																const updatedVolunteers = formik.values.volunteers.map((vol, idx) =>
																	idx === index
																		? {
																				...vol, // copy other properties of this volunteer
																				userId: selectedOptions.map(opt => ({
																					_id: opt.value,
																					firstName: opt.label,
																				})),
																		  }
																		: vol,
																)

																formik.setFieldValue('volunteers', updatedVolunteers)
															}}
															placeholder="Select User..."
															isMulti
														/>
													</div>

													<div className="flex-grow-1 ml-2">
														<input
															type="text"
															className="form-control"
															placeholder="Enter role"
															value={volunteer.role}
															onChange={e => {
																const updated = [...formik.values.volunteers]
																updated[index].role = e.target.value
																formik.setFieldValue('volunteers', updated)
															}}
														/>
													</div>

													<div className="flex-grow-1 ml-2 mr-2">
														<input
															type="number"
															className="form-control"
															placeholder="Enter remaining count"
															value={volunteer.remaining_count}
															onChange={e => {
																const updated = [...formik.values.volunteers]
																updated[index].remaining_count = e.target.value
																formik.setFieldValue('volunteers', updated)
															}}
														/>
													</div>

													<button
														type="button"
														className="btn btn-danger"
														onClick={() => {
															const updated = formik.values.volunteers.filter((_, i) => i !== index)
															formik.setFieldValue('volunteers', updated)
														}}
													>
														Remove
													</button>
												</div>
											))}
										</div>
									)}

									<div className="row">
										<div className="col-md-6">
											<label className="form-label">payment Mode Enabled</label>
											<div>
												<label className="me-3">
													<input
														type="radio"
														name="payment_mode_enabled"
														checked={formik.values.payment_mode_enabled === true}
														onChange={() => formik.setFieldValue('payment_mode_enabled', true)}
													/>{' '}
													Yes
												</label>
												<label className="ml-3">
													<input
														type="radio"
														name="payment_mode_enabled"
														checked={formik.values.payment_mode_enabled === false}
														onChange={e => {
															const checked = e.target.checked
															formik.setFieldValue('payment_mode_enabled', false)
															if (checked) {
																formik.setFieldValue('boli_items', [])
																formik.setFieldTouched('boli_items', [])
																formik.setFieldValue('upi_id', '')
																formik.setFieldValue('upi_id', '')
															}
														}}
													/>{' '}
													No
												</label>
											</div>
										</div>
										{formik.values.payment_mode_enabled && (
											<div className="col-md-6 mb-3">
												<label>UPI Id</label>
												<input
													type="text"
													className="form-control"
													name="upi_id"
													value={formik.values.upi_id}
													placeholder="Enter Upi Id"
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
												/>
												{formik.touched.upi_id && formik.errors.upi_id && (
													<div className="text-danger">{formik.errors.upi_id}</div>
												)}
											</div>
										)}
									</div>

									{formik.values.payment_mode_enabled && (
										<div className="row">
											<div className="col-md-12 mb-3">
												<button
													type="button"
													className="btn btn-primary"
													onClick={() => {
														const updated = [
															...formik.values.boli_items,
															{
																item_name: '',
																amount_required: '',
																amount_received: 0,
																sponsored_by: [],
															},
														]
														formik.setFieldValue('boli_items', updated)
													}}
												>
													Add Boli Item
												</button>
											</div>

											{/* Loop through each Boli Item */}
											{formik.values.boli_items?.map((item, index) => (
												<div className="col-md-12 mb-4 p-3 border rounded shadow-sm" key={index}>
													<div className="row g-2 align-items-center">
														{/* Item Name */}
														<div className="col-md-3">
															<label>Boli Item</label>
															<input
																type="text"
																className="form-control"
																placeholder="Enter Boli Item Name"
																value={item.item_name}
																onChange={e => {
																	const updated = formik.values.boli_items.map((item, idx) =>
																		idx === index ? { ...item, item_name: e.target.value } : item,
																	)
																	formik.setFieldValue('boli_items', updated)
																}}
															/>
														</div>

														{/* Amount Required */}
														<div className="col-md-2">
															<label>Amount Required</label>
															<input
																type="number"
																className="form-control"
																placeholder="Amount Required"
																value={item.amount_required}
																onChange={e => {
																	const updated = formik.values.boli_items.map((item, idx) =>
																		idx === index
																			? {
																					...item,
																					amount_required: e.target.value,
																			  }
																			: item,
																	)
																	formik.setFieldValue('boli_items', updated)
																}}
															/>
														</div>

														<div className="col-md-2">
															<label>Amount Received</label>
															<input
																type="number"
																className="form-control"
																placeholder="Amount Received"
																value={item.amount_received}
																onChange={e => {
																	const value = e.target.value === '' ? 0 : e.target.value
																	const updated = formik.values.boli_items.map((item, idx) =>
																		idx === index ? { ...item, amount_received: value } : item,
																	)
																	formik.setFieldValue('boli_items', updated)
																}}
															/>
														</div>

														<div className="col-md-2">
															<button
																type="button"
																className="btn btn-danger w-100"
																onClick={() => {
																	const updated = formik.values.boli_items.filter(
																		(_, i) => i !== index,
																	)
																	formik.setFieldValue('boli_items', updated)
																}}
															>
																Remove
															</button>
														</div>
													</div>

													<hr className="my-3" />

													<div className="sponsors">
														{/* <label className="fw-bold">Sponsors:</label> */}

														{item.sponsored_by.map((sponsor, sponsorIndex) => (
															<div
																key={sponsorIndex}
																className="d-flex align-items-center mb-2 mr-2 gap-2"
															>
																<div className="flex-grow-1">
																	<label className="form-label">Sponsor</label>
																	<Select
																		options={
																			Array.isArray(users)
																				? users.map(user => ({
																						value: user._id,
																						label: getUserOptionLabel(user),
																				  }))
																				: []
																		}
																		value={
																			sponsor.userId
																				? (() => {
																						const userId =
																							typeof sponsor.userId === 'object'
																								? sponsor.userId._id
																								: sponsor.userId

																						const matchedUser = users.find(u => u._id === userId)

																						return matchedUser
																							? {
																									value: matchedUser._id,
																									label: getUserOptionLabel(matchedUser),
																							  }
																							: {
																									value: userId,
																									label:
																										typeof sponsor.userId === 'object'
																											? getUserOptionLabel(sponsor.userId)
																											: 'Unknown User',
																							  }
																				  })()
																				: null
																		}
																		onChange={selectedOption => {
																			const updated = formik.values.boli_items.map((item, idx) =>
																				idx === index
																					? {
																							...item,
																							sponsored_by: item.sponsored_by.map((s, sIdx) =>
																								sIdx === sponsorIndex
																									? {
																											...s,
																											userId: selectedOption?.value || '',
																									  }
																									: s,
																							),
																					  }
																					: item,
																			)
																			formik.setFieldValue('boli_items', updated)
																		}}
																		placeholder="Select User..."
																	/>
																</div>

																<div className="flex-grow-1 ml-2">
																	<label className="form-label">Amount</label>
																	<input
																		type="number"
																		className="form-control"
																		placeholder="Sponsor Amount"
																		value={sponsor.amount}
																		onChange={e => {
																			const updated = [...formik.values.boli_items]
																			updated[index].sponsored_by[sponsorIndex].amount =
																				e.target.value
																			formik.setFieldValue('boli_items', updated)
																		}}
																	/>
																</div>

																{sponsor.userId && (
																	<>
																		<div className="col-md-2 text-center">
																			<div className="form-group">
																				<label>Status</label>
																				<div>
																					{sponsor.status === 'Paid' ? (
																						<span className="badge badge-success">Paid</span>
																					) : (
																						<span className="badge badge-primary">Pending</span>
																					)}
																				</div>
																			</div>
																		</div>

																		{(!sponsor.status || sponsor.status === 'Pending') && (
																			<div>
																				<button
																					type="button"
																					className="btn btn-sm btn-success ml-1 mr-2"
																					onClick={() =>
																						handleMarkAsPaid(index, sponsorIndex, sponsor)
																					}
																				>
																					<i className="fa fa-check" aria-hidden="true"></i> Mark as
																					Paid
																				</button>
																			</div>
																		)}
																	</>
																)}

																{(!sponsor.userId || sponsor.status !== 'Paid') && (
																	<button
																		type="button"
																		className="btn btn-outline-danger ml-2"
																		onClick={() => {
																			const updated = formik.values.boli_items.map((item, idx) => ({
																				...item,
																				sponsored_by:
																					idx === index
																						? item.sponsored_by.filter(
																								(_, sIdx) => sIdx !== sponsorIndex,
																						  )
																						: [...item.sponsored_by],
																			}))

																			formik.setFieldValue('boli_items', updated)
																		}}
																	>
																		X
																	</button>
																)}
															</div>
														))}
														<button
															type="button"
															className="btn btn-primary mt-2"
															onClick={() => {
																const updated = [...formik.values.boli_items]

																const sponsors = updated[index].sponsored_by
																	? [...updated[index].sponsored_by]
																	: []

																sponsors.push({
																	userId: '',
																	amount: '',
																})

																updated[index] = {
																	...updated[index],
																	sponsored_by: sponsors,
																}

																formik.setFieldValue('boli_items', updated)
															}}
														>
															Add Sponsor
														</button>
													</div>
												</div>
											))}
										</div>
									)}

									<div className="row">
										<div className="col-md-6">
											<label className="form-label">allow photo upload</label>
											<div>
												<label className="me-3">
													<input
														type="radio"
														name="allow_photo_upload"
														checked={formik.values.allow_photo_upload === true}
														onChange={() => formik.setFieldValue('allow_photo_upload', true)}
													/>{' '}
													Yes
												</label>
												<label className="ml-3">
													<input
														type="radio"
														name="allow_photo_upload"
														checked={formik.values.allow_photo_upload === false}
														onChange={() => formik.setFieldValue('allow_photo_upload', false)}
													/>{' '}
													No
												</label>
											</div>
										</div>
										{formik.values.allow_photo_upload === true && (
											<div className="mb-3 col-md-6">
												<MultipleMediaUpload
													uploadFunction={uploadSponsorImage}
													value={formik.values.event_photo_upload}
													fieldName="multiMedia"
													onChange={newFiles => {
														const currentFiles = formik.values.event_photo_upload || []

														const filesToAdd = Array.isArray(newFiles) ? newFiles : [newFiles]

														const mergedFiles = [...currentFiles, ...filesToAdd].filter(
															(file, index, self) =>
																index === self.findIndex(f => f.url === file.url),
														)

														formik.setFieldValue('event_photo_upload', mergedFiles)
													}}
												/>
												{formik.touched.event_photo_upload && formik.errors.event_photo_upload && (
													<div className="text-danger">{formik.errors.event_photo_upload}</div>
												)}
											</div>
										)}
									</div>

									<div className="modal-footer">
										<button type="submit" className="btn btn-success">
											<span>
												<i className="fa fa-check"></i>{' '}
											</span>
											{editEventMode ? 'Update' : 'Create'}
										</button>
										<button
											type="button"
											className="btn btn-secondary"
											onClick={handleCloseEventEdit}
										>
											<i className="fa fa-times"></i> Cancel
										</button>
									</div>
								</form>
								</FormikProvider>
							</div>
						</div>
					</div>
				</div>
			)}

			{showEventDetailsModal && eventDetails && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
							<div className="modal-header">
								<h5>Event Details</h5>
								<button type="button" className="close" onClick={handleCloseEventDetails}>
									x
								</button>
							</div>

							<div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
								<div className=" mb-3">
									{eventDetails.file ? (
										eventDetails.file.endsWith('.mp4') ? (
											<video
												controls
												style={{
													width: '70%',
													maxHeight: '200px',
													borderRadius: '10px',
												}}
												src={eventDetails.file}
											/>
										) : (
											<img
												src={eventDetails.file}
												alt="Event"
												style={{
													width: '50%',
													maxHeight: '100px',
													borderRadius: '10px',
													objectFit: 'contain',
												}}
											/>
										)
									) : (
										<p className="text-muted">No event file uploaded</p>
									)}
									<h5 className="modal-title">
										<strong>Event:</strong> {eventDetails.title}
									</h5>
									<strong>Description:</strong>
									<div
										className=" p-2 mt-1"
										dangerouslySetInnerHTML={{
											__html: eventDetails.description,
										}}
									/>
								</div>

								<div className="row mb-3">
									<div className="col-md-6">
										<strong>Community:</strong>
										{eventDetails.hub ? (
											<div className="d-flex align-items-center mt-1">
												<img
													src={eventDetails?.hub?.image}
													alt="Hub"
													style={{
														width: '40px',
														height: '40px',
														borderRadius: '50%',
														marginRight: '10px',
													}}
												/>
												<span>{eventDetails?.hub?.name}</span>
											</div>
										) : (
											<p className="text-muted">N/A</p>
										)}
									</div>
									<div className="col-md-6">
										<strong>Sanstha:</strong>
										{eventDetails.sanstha ? (
											<div className="d-flex align-items-center mt-1">
												<img
													src={eventDetails.sanstha.image}
													alt="Sanstha"
													style={{
														width: '40px',
														height: '40px',
														borderRadius: '50%',
														marginRight: '10px',
													}}
												/>
												<span>{eventDetails.sanstha.name}</span>
											</div>
										) : (
											<p className="text-muted">N/A</p>
										)}
									</div>
								</div>

								<div className="row mb-3">
									<div className="col-md-6">
										<p>
											<strong>Category:</strong> {eventDetails.category}
										</p>
										{/* <p><strong>Status:</strong> {eventDetails.status}</p> */}
									</div>
									<div className="col-md-6">
										<p>
											<strong>Start Date:</strong>{' '}
											{new Date(eventDetails.startDate).toLocaleDateString()}
										</p>
										<p>
											<strong>End Date:</strong>{' '}
											{new Date(eventDetails.endDate).toLocaleDateString()}
										</p>
									</div>
								</div>

								<div className="mb-3">
									<strong>Location:</strong>
									{eventDetails.locationType === 'Physical' ? (
										<div className="mt-1">
											<div>
												{eventDetails.nativePlaceAddress}, {eventDetails.nativeArea}
											</div>
											<div>
												{eventDetails.nativeBlock}, {eventDetails.nativeDistrict},{' '}
												{eventDetails.nativeState} {eventDetails.nativePlacePincode}
											</div>
										</div>
									) : (
										<a
											href={eventDetails.virtualLink}
											target="_blank"
											rel="noopener noreferrer"
											className="text-primary"
										>
											{eventDetails.virtualLink}
										</a>
									)}
								</div>

								{eventDetails.payment_mode_enabled && (
									<div className="mb-3">
										<strong>UPI ID:</strong> {eventDetails.upi_id}
									</div>
								)}

								<div className="row mb-3">
									<div className="col-md-6">
										<p>
											<strong>RSVP Enabled:</strong> {eventDetails.RSVP_Enabled ? 'Yes' : 'No'}
										</p>
										<p>
											<strong>RSVP Limit:</strong> {eventDetails.RSVP_limit}
										</p>
										<p>
											<strong>RSVP Deadline:</strong>{' '}
											{eventDetails.RSVP_deadline
												? new Date(eventDetails.RSVP_deadline).toLocaleDateString()
												: 'N/A'}
										</p>
									</div>
									<div className="col-md-6">
										<p>
											<strong>Volunteers Allowed:</strong>{' '}
											{eventDetails.Allow_Vlonteers ? 'Yes' : 'No'}
										</p>
										<p>
											<strong>Waitlist Enabled:</strong>{' '}
											{eventDetails.Waitlist_Enabled ? 'Yes' : 'No'}
										</p>
									</div>
								</div>

								{eventDetails.volunteers?.length > 0 && (
									<div className="mb-3">
										<strong>Volunteers:</strong>
										<ul className="mt-1">
											{eventDetails.volunteers.map((vol, volIndex) => (
												<li key={vol._id || volIndex} className="mb-3">
													<p className="font-semibold">
														Role: {vol.role} | Remaining Count: {vol.remaining_count}
													</p>

													{/* Display each user in this volunteer group */}
													<div className="row mt-2">
														{vol.userId.map(user => (
															<div
																key={user._id}
																className="flex items-center gap-3 p-2 bg-gray-100 rounded-lg"
															>
																<img
																	src={user.profilePic || '/img/user.jpg'}
																	alt={user.firstName}
																	className="rounded-full object-cover"
																	height={70}
																	width={70}
																/>
																<div>
																	<p className="font-medium">
																		{user.firstName} {user.lastName}
																	</p>
																	<p className="text-sm text-gray-600">{user.mobile}</p>
																</div>
															</div>
														))}
													</div>
												</li>
											))}
										</ul>
									</div>
								)}

								{Array.isArray(eventDetails?.event_photo_upload) &&
									eventDetails.event_photo_upload.length > 0 && (
										<div className="mb-3">
											<strong>Event Upload Photos:</strong>
											<div className="mt-3 border-b pb-2">
												<div className="row mt-2">
													{eventDetails.event_photo_upload.map((photo, index) => (
														<div key={index} className="flex flex-row gap-2">
															{photo.type === 'video/mp4' ? (
																<video
																	controls
																	style={{
																		width: '100px',
																		maxHeight: '100px',
																		borderRadius: '10px',
																		marginLeft: '5px',
																	}}
																	src={photo.url}
																/>
															) : (
																<img
																	src={photo.url}
																	alt="event upload"
																	style={{
																		width: '100px',
																		maxHeight: '100px',
																		borderRadius: '10px',
																		objectFit: 'cover',
																		marginLeft: '5px',
																	}}
																/>
															)}
														</div>
													))}
												</div>
											</div>
										</div>
									)}

								{eventDetails?.boli_items?.length > 0 && (
									<div className="mb-3">
										<strong className="block mb-2">Boli Items:</strong>
										<div className="row flex flex-col gap-6">
											{eventDetails.boli_items.map((item, index) => (
												<div key={index} className="p-3  rounded-lg  bg-white space-y-2">
													<p>
														<strong>Item Name:</strong> {item.item_name}
													</p>
													<p>
														<strong>Amount Required:</strong> ₹{item.amount_required}
													</p>
													<p>
														<strong>Amount Received:</strong> ₹{item.amount_received}
													</p>

													{Array.isArray(item.sponsored_by) && item.sponsored_by.length > 0 ? (
														<div className="grid grid-cols-5 gap-4 mt-2">
															{item.sponsored_by.map((sponsor, sIndex) => (
																<div
																	key={sIndex}
																	className="flex flex-col items-center bg-gray-50 p-2 rounded"
																>
																	<img
																		src={sponsor.userId?.profilePic || '/img/user.jpg'}
																		alt={sponsor.userId?.firstName || 'Sponsor'}
																		className=" object-cover"
																		width={50}
																		height={50}
																	/>
																	<span className="text-sm text-center mt-1">
																		{sponsor.userId?.firstName} {sponsor.userId?.lastName}
																	</span>
																</div>
															))}
														</div>
													) : (
														<p className="text-gray-500">No sponsors yet.</p>
													)}
												</div>
											))}
										</div>
									</div>
								)}

								<div>
									{participants.length > 0 && (
										<>
											<h6 className="font-bold mb-3 text-green-600">Joinee</h6>
											<div className="row mt-2">
												{participants
													.filter(p => p.status === 'Accepted')
													.map(participant => (
														<div
															key={participant.userId._id}
															className="flex items-center gap-3 p-2 bg-gray-100 rounded-lg"
														>
															<img
																src={participant?.userId?.profilePic || '/img/user.jpg'}
																alt={participant?.userId?.firstName}
																className="rounded-full object-cover"
																height={70}
																width={70}
															/>
															<div>
																<p className="font-medium">
																	{participant.userId.firstName} {participant.userId.lastName}
																</p>
																<p className="text-sm text-gray-600">{participant.userId.mobile}</p>
															</div>
														</div>
													))}
											</div>

											{/* Rejected Section */}
											{participants.some(p => p.status === 'Rejected') && (
												<>
													<h6 className="font-bold mb-3 text-red-600 mt-6">
														Rejected Participants
													</h6>
													<div className="row mt-2 ml-3">
														{participants
															.filter(p => p.status === 'Rejected')
															.map(participant => (
																<div
																	key={participant.userId._id}
																	className="flex items-center gap-3 p-2 bg-gray-100 rounded-lg"
																>
																	<img
																		src={participant.userId.profilePic || '/img/user.jpg'}
																		alt={participant.userId.firstName}
																		className="rounded-full object-cover"
																		height={70}
																		width={70}
																	/>
																	<div>
																		<p className="font-semibold">
																			{participant.userId.firstName} {participant.userId.lastName}
																		</p>
																		<p className="text-sm text-gray-600">
																			{participant.userId.mobile}
																		</p>
																	</div>
																</div>
															))}
													</div>
												</>
											)}
										</>
									)}
								</div>

								{/* <div className="text-muted mt-3">
            <small>Created: {new Date(eventDetails.createdAt).toLocaleString()}</small>
            <br />
            <small>Updated: {new Date(eventDetails.updatedAt).toLocaleString()}</small>
          </div> */}
							</div>

							{/* Footer */}
							<div className="modal-footer">
								<button className="btn btn-secondary" onClick={handleCloseEventDetails}>
									Close
								</button>
							</div>
						</div>
					</div>
				</div>
			)}

			{showPaymentPopup && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog modal-lg">
						<div className="modal-content shadow-lg rounded-3">
							<div className="modal-header bg-primary text-white">
								<h5 className="modal-title">Project Payment Details</h5>
								<button
									type="button"
									className="btn-close btn-close-white"
									onClick={() => setShowPaymentPopup(false)}
								></button>
							</div>

							<div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
								<div className="row">
									<div className="col-md-6">
										<label className="form-label">payment Mode Enabled</label>
										<div>
											<label className="me-3">
												<input
													type="radio"
													name="payment_mode_enabled"
													checked={formik.values.payment_mode_enabled === true}
													onChange={() => formik.setFieldValue('payment_mode_enabled', true)}
												/>{' '}
												Yes
											</label>
											<label className="ml-3">
												<input
													type="radio"
													name="payment_mode_enabled"
													checked={formik.values.payment_mode_enabled === false}
													onChange={e => {
														const checked = e.target.checked
														formik.setFieldValue('payment_mode_enabled', false)
														if (checked) {
															formik.setFieldValue('boli_items', [])
															formik.setFieldTouched('boli_items', [])
															formik.setFieldValue('upi_id', '')
															formik.setFieldValue('upi_id', '')
														}
													}}
												/>{' '}
												No
											</label>
										</div>
									</div>
									{formik.values.payment_mode_enabled && (
										<div className="col-md-6 mb-3">
											<label>UPI Id</label>
											<input
												type="text"
												className="form-control"
												name="upi_id"
												value={formik.values.upi_id}
												placeholder="Enter Upi Id"
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
											/>
											{formik.touched.upi_id && formik.errors.upi_id && (
												<div className="text-danger">{formik.errors.upi_id}</div>
											)}
										</div>
									)}
								</div>
								{formik.values.payment_mode_enabled && (
									<div className="row">
										<div className="col-md-12 mb-3">
											<button
												type="button"
												className="btn btn-primary"
												onClick={() => {
													const updated = [
														...formik.values.boli_items,
														{
															item_name: '',
															amount_required: '',
															amount_received: 0,
															sponsored_by: [],
														},
													]
													formik.setFieldValue('boli_items', updated)
												}}
											>
												Add Boli Item
											</button>
										</div>

										{formik.values.boli_items?.map((item, index) => (
											<div className="col-md-12 mb-4 p-3 border rounded shadow-sm" key={index}>
												<div className="row g-2 ">
													<div className="col-md-3">
														<label>Boli Item</label>
														<input
															type="text"
															className="form-control"
															placeholder="Enter Boli Item Name"
															value={item.item_name}
															onChange={e => {
																const updated = formik.values.boli_items.map((item, idx) =>
																	idx === index ? { ...item, item_name: e.target.value } : item,
																)
																formik.setFieldValue('boli_items', updated)
															}}
														/>
														{formik.touched.boli_items?.[index]?.item_name &&
															formik.errors.boli_items?.[index]?.item_name && (
																<div className="text-danger">
																	{formik.errors.boli_items[index].item_name}
																</div>
															)}
													</div>

													<div className="col-md-3">
														<label>Amount Required</label>
														<input
															type="number"
															className="form-control"
															placeholder="Amount Required"
															value={item.amount_required}
															onChange={e => {
																const updated = formik.values.boli_items.map((item, idx) =>
																	idx === index
																		? {
																				...item,
																				amount_required: e.target.value,
																		  }
																		: item,
																)
																formik.setFieldValue('boli_items', updated)
															}}
														/>
														{formik.touched.boli_items?.[index]?.amount_required &&
															formik.errors.boli_items?.[index]?.amount_required && (
																<div className="text-danger">
																	{formik.errors.boli_items[index].amount_required}
																</div>
															)}
													</div>

													<div className="col-md-3">
														<label>Amount Received</label>
														<input
															type="number"
															className="form-control"
															placeholder="Amount Received"
															value={item.amount_received}
															onChange={e => {
																const value = e.target.value === '' ? 0 : e.target.value
																const updated = formik.values.boli_items.map((item, idx) =>
																	idx === index ? { ...item, amount_received: value } : item,
																)
																formik.setFieldValue('boli_items', updated)
															}}
														/>
														{formik.touched.boli_items?.[index]?.amount_received &&
															formik.errors.boli_items?.[index]?.amount_received && (
																<div className="text-danger">
																	{formik.errors.boli_items[index].amount_received}
																</div>
															)}
													</div>

													<div className="col-md-3">
														<button
															type="button"
															className="btn btn-danger w-100"
															onClick={() => {
																const updated = formik.values.boli_items.filter(
																	(_, i) => i !== index,
																)
																formik.setFieldValue('boli_items', updated)
															}}
														>
															Remove
														</button>
													</div>
												</div>

												<hr className="my-3" />

												<div className="sponsors">
													{item.sponsored_by.map((sponsor, sponsorIndex) => (
														<div
															key={sponsorIndex}
															className="row align-items-end mb-3 p-2 border rounded bg-light"
														>
															<div className="col-md-4">
																<label>Sponsor</label>
																<Select
																	options={
																		Array.isArray(users)
																			? [
																					...users.map(user => ({
																						value: user._id,
																						label: getUserOptionLabel(user),
																					})),
																					// If sponsor.userId is not found in users, add it manually
																					...(sponsor.userId &&
																					!users.some(
																						u =>
																							u._id ===
																							(typeof sponsor.userId === 'object'
																								? sponsor.userId._id
																								: sponsor.userId),
																					)
																						? [
																								{
																									value:
																										typeof sponsor.userId === 'object'
																											? sponsor.userId._id
																											: sponsor.userId,
																									label:
																										typeof sponsor.userId === 'object'
																											? getUserOptionLabel(sponsor.userId)
																											: 'Unknown User',
																								},
																						  ]
																						: []),
																			  ]
																			: []
																	}
																	value={
																		sponsor.userId
																			? (() => {
																					const userId =
																						typeof sponsor.userId === 'object'
																							? sponsor.userId._id
																							: sponsor.userId

																					const matchedUser = users.find(u => u._id === userId)

																					return matchedUser
																						? {
																								value: matchedUser._id,
																								label: getUserOptionLabel(matchedUser),
																						  }
																						: {
																								value: userId,
																								label:
																									typeof sponsor.userId === 'object'
																										? getUserOptionLabel(sponsor.userId)
																										: 'Unknown User',
																						  }
																			  })()
																			: null
																	}
																	onChange={selectedOption => {
																		const updated = formik.values.boli_items.map((item, idx) =>
																			idx === index
																				? {
																						...item,
																						sponsored_by: item.sponsored_by.map((s, sIdx) =>
																							sIdx === sponsorIndex
																								? {
																										...s,
																										userId: selectedOption?.value || '',
																										status: s.status || 'Pending',
																								  }
																								: s,
																						),
																				  }
																				: item,
																		)
																		formik.setFieldValue('boli_items', updated)
																	}}
																	placeholder="Select Sponsor..."
																/>
																{formik.touched.boli_items?.[index]?.sponsored_by?.[sponsorIndex]
																	?.userId &&
																	formik.errors.boli_items?.[index]?.sponsored_by?.[sponsorIndex]
																		?.userId && (
																		<div className="text-danger">
																			{
																				formik.errors.boli_items[index].sponsored_by[sponsorIndex]
																					.userId
																			}
																		</div>
																	)}
															</div>

															<div className="d-flex align-items-center mb-2 mr-2 gap-2">
																<div className="flex-grow-1 ml-2">
																	<label>Sponsor Amount</label>
																	<input
																		type="number"
																		className="form-control"
																		placeholder="Sponsor Amount"
																		value={sponsor.amount}
																		onChange={e => {
																			const updated = [...formik.values.boli_items]
																			updated[index].sponsored_by[sponsorIndex].amount =
																				e.target.value
																			formik.setFieldValue('boli_items', updated)
																		}}
																	/>
																	{formik.touched.boli_items?.[index]?.sponsored_by?.[sponsorIndex]
																		?.amount &&
																		formik.errors.boli_items?.[index]?.sponsored_by?.[sponsorIndex]
																			?.amount && (
																			<div className="text-danger">
																				{
																					formik.errors.boli_items[index].sponsored_by[sponsorIndex]
																						.amount
																				}
																			</div>
																		)}
																</div>
															</div>

															{sponsor.userId && (
																<>
																	<div className="col-md-1 mr-4">
																		<div className="form-group">
																			<label>Status</label>
																			<div>
																				{sponsor.status === 'Paid' ? (
																					<span className="badge badge-success">Paid</span>
																				) : (
																					<span className="badge badge-primary">Pending</span>
																				)}
																			</div>
																		</div>
																	</div>

																	{(!sponsor.status || sponsor.status === 'Pending') && (
																		<div>
																			<button
																				type="button"
																				className="btn btn-sm btn-success  mr-2"
																				onClick={() =>
																					handleMarkAsPaid(index, sponsorIndex, sponsor)
																				}
																			>
																				<i className="fa fa-check" aria-hidden="true"></i> Mark as
																				Paid
																			</button>
																		</div>
																	)}
																</>
															)}

															{(!sponsor.userId || sponsor.status !== 'Paid') && (
																<button
																	type="button"
																	className="btn btn-outline-danger ml-2"
																	onClick={() => {
																		const updated = [...formik.values.boli_items]
																		updated[index].sponsored_by.splice(sponsorIndex, 1)
																		formik.setFieldValue('boli_items', updated)
																	}}
																>
																	X
																</button>
															)}
														</div>
													))}

													<button
														type="button"
														className="btn btn-primary mt-2"
														onClick={() => {
															const updated = [...formik.values.boli_items]

															const sponsors = updated[index].sponsored_by
																? [...updated[index].sponsored_by]
																: []

															sponsors.push({
																userId: '',
																amount: '',
																status: 'Pending',
															})

															updated[index] = {
																...updated[index],
																sponsored_by: sponsors,
															}

															formik.setFieldValue('boli_items', updated)
														}}
													>
														Add Sponsor
													</button>
												</div>
											</div>
										))}
									</div>
								)}
							</div>

							<div className="modal-footer">
								<button type="button" className="btn btn-primary" onClick={handleSave}>
									Save
								</button>
								<button className="btn btn-secondary px-4" onClick={handleCloseModal}>
									Close
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default Event
